import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

/**
 * Dialog di conferma post-incasso con CTA "Continua in Cassa" / "Torna in Agenda".
 * Estratto da Cassa.jsx per ridurne le dimensioni.
 */
export default function IncassoCompletatoDialog({
  incasso,
  onClose,
  onTornaAgenda,
}) {
  return (
    <Dialog open={!!incasso} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        className="w-[95vw] sm:max-w-md p-5 rounded-2xl border-4 border-transparent shadow-2xl"
        style={{
          backgroundImage: 'linear-gradient(white, white), linear-gradient(135deg, #10b981, #14b8a6, #06b6d4)',
          backgroundOrigin: 'border-box',
          backgroundClip: 'padding-box, border-box'
        }}
        data-testid="dialog-incasso-completato"
      >
        <div className="text-center py-4 space-y-4">
          <div className="w-16 h-16 mx-auto rounded-full bg-emerald-100 flex items-center justify-center">
            <CheckCircle2 className="w-9 h-9 text-emerald-600" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-slate-800">Incasso completato!</h3>
            <p className="text-sm text-slate-500 mt-1">
              <span className="font-semibold">{incasso?.cliente}</span> &middot; €{incasso?.totale?.toFixed(2)} via {incasso?.metodo}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 pt-2">
            <Button
              variant="outline"
              className="flex-1 h-11"
              onClick={onClose}
              data-testid="btn-continua-cassa"
            >
              Continua in Cassa
            </Button>
            <Button
              className="flex-1 h-11 bg-gradient-to-r from-blue-500 to-violet-500 hover:from-blue-600 hover:to-violet-600 text-white font-semibold"
              onClick={onTornaAgenda}
              data-testid="btn-torna-agenda-cassa"
            >
              📅 Torna in Agenda
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
